export default __webpack_public_path__ + "static/media/S4xCLUES3.77ac2953.jpg";